export const SIDEBAR_CONSTANT = {
  MENU_ACCOUNT_LIST: 'Account List',
  MENU_DASHBOARD: 'Dashboard',

  MENU_SETTING_LIST: 'Setting List',
}